import React from 'react';
import { Box, ButtonProps } from '@mui/material';

import { useAppSelector } from '../../../../hooks';
import { TP_COLORS } from '../../../../constants';
import { getUsersState } from '../../../../store/UserSlice';

import ExperienceSection from './components/ExperienceSection';
import QualificationSection from './components/QualificationSection';
import AchievementSection from './components/AchievementSection';
import LanguageSection from './components/LanguageSection';

export const addButtonProps: ButtonProps = {
  disableElevation: true,
  variant: 'contained',
  color: 'secondary',
  sx: {
    width: '94px',
    height: '45px',
    color: '#F8FAFC',
    fontWeight: '600',
    borderRadius: '5px',
    backgroundColor: TP_COLORS.gray.darken,
  },
};

export const dismissButtonProps: ButtonProps = {
  disableElevation: true,
  variant: 'contained',
  color: 'inherit',
  sx: {
    width: '94px',
    height: '45px',
    color: TP_COLORS.gray.darken,
    fontWeight: '600',
    borderRadius: '5px',
    backgroundColor: TP_COLORS.border.color1,
  },
};

const AdminQualificationsExperience: React.FC = () => {
  // Store
  const usersState = useAppSelector(getUsersState);
  const userProfile = usersState?.user?.profile;

  const experienceList = userProfile?.experiences || [];
  const qualificationList = userProfile?.qualifications || [];
  const achievementList = userProfile?.achievements || [];
  const languageList = userProfile?.languages || [];

  return (
    <Box>
      {/* Teaching Experience */}
      <ExperienceSection experienceList={experienceList} />

      {/* Qualification */}
      <QualificationSection qualificationList={qualificationList} />

      {/* Achievement */}
      <AchievementSection achievementList={achievementList} />

      {/* Language */}
      <LanguageSection languageList={languageList} />
    </Box>
  );
};

export default AdminQualificationsExperience;
